import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=1b67cb3c&scoped=true"
import script from "./_slug.vue?vue&type=script&lang=js"
export * from "./_slug.vue?vue&type=script&lang=js"
import style0 from "./_slug.vue?vue&type=style&index=0&id=1b67cb3c&prod&lang=scss"
import style1 from "./_slug.vue?vue&type=style&index=1&id=1b67cb3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b67cb3c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Breadcrumbs: require('/app/components/global/breadcrumbs.vue').default,MainInfoUser: require('/app/components/global/MainInfoUser.vue').default,ProfileStatus: require('/app/components/profile/profile-status.vue').default,VBtn: require('/app/node_modules/vuetify/lib/components/VBtn/VBtn.js').default,ProfileTabNavigation: require('/app/components/profile/profile-tab-navigation.vue').default,ProfileSubscribe: require('/app/components/profile/profile-subscribe.vue').default,ProfileComments: require('/app/components/profile/profile-comments.vue').default,ProfileSidebar: require('/app/components/profile/profile-sidebar.vue').default,VIcon: require('/app/node_modules/vuetify/lib/components/VIcon/VIcon.js').default,IconMessageLightGrey: require('/app/components/icons/IconMessageLightGrey.vue').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VExpandTransition,VIcon})
